import { Icon } from './Icon';
import { HeroFlowCard } from './HeroFlowCard';
import { smoothScrollTo } from '../hooks';

export function Hero() {
  return (
    <header className="lp-hero" id="top">
      <div className="mx-auto w-full max-w-[1180px] px-7 lp-hero-grid">
        <div className="reveal reveal-left">
          <span className="lp-eyebrow"><Icon name="phone" size={13} /> AI Voice Agents for Shopify</span>
          <h1 className="text-[clamp(40px,6vw,68px)] font-extrabold tracking-[-0.035em] leading-[1.02]">
            Recover Carts.<br />Confirm Orders.<br /><span className="text-orange-500">Answer Calls.</span> 24/7.
          </h1>
          <p className="text-[clamp(16px,1.5vw,19px)] text-[var(--text-2)] leading-[1.6] lp-hero-sub">
            CallXcel turns missed Shopify moments into real conversations: abandoned carts, order confirmations, delivery issues, returns and support calls, all handled by AI voice agents around the clock.
          </p>
          <div className="lp-hero-cta">
            <button className="lp-btn lp-btn-orange lp-btn-lg" onClick={() => smoothScrollTo('top')}>
              Try 50 AI calls free <Icon name="arrow-right" size={17} />
            </button>
            <button className="lp-btn lp-btn-ghost lp-btn-lg" onClick={() => smoothScrollTo('how')}>
              <Icon name="play" size={15} /> See how it works
            </button>
          </div>
          <div className="lp-hero-trust">
            <div className="lp-trust-item">
              <div className="lp-avatars">
                <span style={{ background: 'linear-gradient(135deg,#2d3a72,#243064)' }}>R</span>
                <span style={{ background: 'linear-gradient(135deg,#e06408,#f57b1d)' }}>A</span>
                <span style={{ background: 'linear-gradient(135deg,#0f9d58,#20c473)' }}>D</span>
                <span style={{ background: 'var(--navy-500)' }}>+</span>
              </div>
              <span>Trusted by 400+ Shopify stores</span>
            </div>
            <div className="lp-trust-item">
              <Icon name="check" size={15} color="var(--success)" /> No coding required
            </div>
          </div>
        </div>

        <div className="reveal reveal-right">
          <HeroFlowCard />
        </div>
      </div>
    </header>
  );
}
